/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type PublicationWarning = typeof PublicationWarning[keyof typeof PublicationWarning];


export const PublicationWarning = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_4: 4,
} as const;
